import React from "react";
import './Button.css';

const Button=({title, action, id, additionalStyle, disable,optionalTitle })=>{
    const handleButtonAction=()=>{
        if(action){
            action();
        }
    }
    return(
    <>
    <button id={id} onClick={handleButtonAction} className={`basic-button ${additionalStyle}`} disabled={disable} >{optionalTitle && (<span className="optionalTitle">{optionalTitle}</span>)}{title}</button>
    </>
    );
}
export default Button;